<p-dialog #newSegmentDialog
          (onShow)="focusDialog()"
          [closable]="false"
          [draggable]="false"
          [modal]="true"
          [resizable]="false"
          [responsive]="true"
          [style]="{ width: '750px' }"
          [visible]="segmentEditor.segment"
          position="top">
  <ng-template pTemplate="header">
    <div class="p-fluid w-100">
      <ng-container *ngIf="segmentEditor.segment && segmentEditor.segment.id; else newSegmentTypeTemplate">
        {{ segmentEditor.segment.type.name }}
      </ng-container>
      <ng-template #newSegmentTypeTemplate>
        <p-dropdown #newSegmentDropdown
                    [(ngModel)]="newSegmentType"
                    [options]="$any(segmentTypes | async)"
                    appendTo="body"
                    lb-events
                    optionLabel="display"
                    optionValue="value"></p-dropdown>
      </ng-template>
    </div>
  </ng-template>
  <div>
    <lb-segment-editor #segmentEditor [template]="template" [segment]="segmentEditor.segment"
                       (onSave)="onSegmentSaved($event)"></lb-segment-editor>
  </div>
  <ng-template pTemplate="footer">
    <div class="w-100 p-d-flex p-jc-end p-ai-center">
      <button pButton class="p-button-secondary" (click)="segmentEditor.segment = undefined">
        <span class="inline-flex justify-between items-center gap-x-2">
          <p-tag styleClass="keyboard-shortcut-tag">
            <span class="font-thin text-xs">Esc</span>
          </p-tag>
          <span>Cancel</span>
        </span>
      </button>
      <button pButton class="p-button-success" [disabled]="segmentEditor.formGroup?.invalid"
              (click)="segmentEditor.save()">
        <span class="inline-flex justify-between items-center gap-x-2">
          <span class="inline-flex items-center gap-x-1">
            <p-tag styleClass="keyboard-shortcut-tag">
              <span class="font-thin text-xs">Ctrl</span>
            </p-tag>
            <p-tag styleClass="keyboard-shortcut-tag">
              <span class="font-thin text-xs">Enter</span>
            </p-tag>
          </span>
          <span>Save</span>
        </span>
      </button>
    </div>
  </ng-template>
</p-dialog>

<div>
  <div class="flex">
    <label class="m-0 inline-flex items-center self-center" *ngIf="hasObsolete">
        <span class="p-mr-2">Show obsolete</span>
        <p-inputSwitch [(ngModel)]="showObsolete"></p-inputSwitch>
    </label>
    <div class="ml-auto flex justify-end self-center">
      <button pButton
              class="p-button-secondary p-button-text"
              [icon]="Icons.CHEVRON_DOWN"
              label="Expand all"
              (click)="toggleAll(true)"
              pTooltip="Expand all segments">
      </button>
      <button pButton
              class="p-button-secondary p-button-text"
              [icon]="Icons.CHEVRON_UP"
              label="Collapse all"
              (click)="toggleAll(false)"
              pTooltip="Collapse all segments">
      </button>
    </div>
  </div>
  <div class="template-editor-tree" (animationend)="onHighlightEnd($event)" (animationcancel)="onHighlightEnd($event)">
    <p-tree #uiTree
              [value]="treeNodes"
              [propagateSelectionUp]="false"
              [draggableNodes]="$any(hoverSupported$ | async)"
              [droppableNodes]="true"
              [validateDrop]="true"
              [loading]="loading"
              [selectionMode]="'checkbox'"
              [(selection)]="selected"
              (onNodeSelect)="onSelectClicked($event)"
              (onNodeDrop)="onDrop($event)">
      <ng-template pTemplate="empty">
        <div class="flex justify-center items-center">
          <span>No segments</span>
        </div>
      </ng-template>
      <ng-template let-node pTemplate="default">
        <p-overlayPanel [showCloseIcon]="true" #restoreObsoleteDialog>
          <ng-template pTemplate>
            <div class="grid grid-flow-col-dense gap-3">
              <div class="mr-3 col-span-2 flex gap-x-2">
                <i [class]="Icons.REFRESH"></i>
                <label class="m-0">Restore</label>
              </div>
              <div class="row-start-2 col-span-2 flex justify-center">
                Restore {{ this.getName(node.data, "this " + node.data?.type.name + " segment") }}?
              </div>
              <div class="row-start-3 col-span-2 flex justify-end">
                <button (click)="onSegmentRestore(node.data, true); restoreObsoleteDialog.hide()"
                        class="p-button-success"
                        [icon]="Icons.CHECK"
                        label="Confirm"
                        pButton></button>
              </div>
            </div>
          </ng-template>
        </p-overlayPanel>
        <div [attr.data-segment-id]="node.data?.id ?? -1"
             [id]="getNodeIdValue(node.data?.id)"
             [ngClass]="{highlight: highlightSegments.has(node.data?.id ?? -1)}">
          <ng-container *ngIf="!node.data || node.data.type.id === SEGMENT_TYPE.SUB_TEMPLATE; else outletTemplate">
            <div class="p-grid p-nogutter">
              <div class="p-col-6 p-d-flex p-flex-column p-jc-center">
                <div class="inline-block">
                  <button (click)="editSectionNode(node)"
                          [label]="getName(node.data)"
                          class="p-button-text label-button font-black"
                          pButton></button>
                </div>
                <p-tag *ngIf="node.data?.obsolete"
                       styleClass="clickable"
                       (click)="restoreObsoleteDialog.show($event)"
                       severity="warning"
                       value="Obsolete"></p-tag>
              </div>
              <div class="p-col-6 p-d-flex p-jc-end p-ai-center">
                <ng-container
                  *ngTemplateOutlet="sectionMenuTemplate; context: createTemplateContext(node)"></ng-container>
                <ng-container
                  *ngTemplateOutlet="overflowMenuTemplate; context: createTemplateContext(node)"></ng-container>
              </div>
            </div>
          </ng-container>
        </div>
        <ng-template #outletTemplate>
          <div *ngVar="segmentOpenMap[node.data.id ?? -1] as segmentOpen" [ngClass]="{closed: !segmentOpen}"
               class="segment-detail-container @container flex">
            <div class="flex flex-col items-start">
              <button pButton
                      class="p-button-text"
                      pTooltip="Edit {{getName(node.data, node.data.type.name + ' segment')}}"
                      [icon]="Icons.PENCIL"
                      (click)="segmentEditor.segment = node.data"></button>
              <button pButton
                      class="p-button-text p-button-secondary segment-detail-expander"
                      [pTooltip]="segmentOpen ? 'Hide details' : 'Show details'"
                      (click)="segmentOpenMap[node.data.id ?? -1] = !segmentOpen"
                      [icon]="Icons.CHEVRON_UP">
              </button>
            </div>
            <div class="segment-detail-grid">
              <div class="segment-detail-title flex flex-col items-start col-span-2 @lg:col-span-1">
                <button (click)="segmentEditor.segment = node.data"
                        *ngIf="getName(node.data, '') as segmentName"
                        class="p-button-text font-black text-lg label-button"
                        pButton>
                  {{ segmentName }}
                </button>
                <span class="font-semibold segment-type">{{ node.data.type.name }}</span>
                <p-tag *ngIf="node.data?.obsolete"
                       styleClass="clickable"
                       (click)="restoreObsoleteDialog.show($event)"
                       severity="warning"
                       value="Obsolete"></p-tag>
              </div>
              <div class="@container segment-detail-content">
                <ng-container *ngIf="node.data">
                  <ng-container
                    *ngTemplateOutlet="segmentContentTemplate; context: createTemplateContext(node.data)">
                  </ng-container>
                </ng-container>
              </div>
              <div class="segment-detail-overflow flex justify-end items-start">
                <div>
                  <ng-container
                    *ngTemplateOutlet="overflowMenuTemplate; context: createTemplateContext(node)"></ng-container>
                </div>
              </div>
              <div class="col-span-full flex">
                <ng-container *ngTemplateOutlet="addSegmentButton; context: createTemplateContext(null, { 'prevId': node.data.id, tooltip: 'Add segment after ' + getName(node.data) })"></ng-container>
              </div>
            </div>
          </div>
        </ng-template>
      </ng-template>
      <ng-template let-node pTemplate="section-footer">
        <div class="section-footer flex justify-between items-center">
          <span class="font-thin text-sm">{{node.label}}</span>
          <div class="flex justify-end items-center flex-wrap">
            <ng-container *ngTemplateOutlet="addSectionButton; context: { disabled: node.data.level >= 5, relativeTo: 'into', parent: node.parent, label: 'Subsection', tooltip: 'Add section into ' + getName(node.data) }"></ng-container>
            <ng-container *ngTemplateOutlet="addSegmentButton; context: { prevId: node.prevId, tooltip: 'Add segment into ' + getName(node.data) }"></ng-container>
          </div>
        </div>
      </ng-template>
    </p-tree>
  </div>
  <div class="flex justify-end">
    <ng-container *ngTemplateOutlet="segmentFooterButtons"></ng-container>
  </div>
</div>

<ng-template #segmentContentTemplate let-segment>
  <div class="segment-content-grid">
    <div *ngIf="hasProperties(segment.type, 'required', 'key', 'calculate', 'variable')"
         class="col-span-full grid gap-y-4 grid-cols-subgrid @lg:grid-cols-4">
      <div *ngIf="templateSegmentSupportsProperty('required', segment)"
           class="segment-prop">
        <span class="font-semibold">Required</span>
        <span>{{ segment.required ? 'Yes' : 'No' }}</span>
      </div>
      <div *ngIf="templateSegmentSupportsProperty('key', segment)"
           class="segment-prop">
        <span class="font-semibold">Key</span>
        <span>{{ segment.key ? 'Yes' : 'No' }}</span>
      </div>
      <div *ngIf="templateSegmentSupportsProperty('calculate', segment)"
           class="segment-prop">
        <span class="font-semibold">Calculate</span>
        <span>{{ segment.calculate ? 'Yes' : 'No' }}</span>
      </div>
      <div *ngIf="templateSegmentSupportsProperty('variable', segment)"
           class="segment-prop">
        <span class="font-semibold">Variable</span>
        <span>{{ segment.variable ? 'Yes' : 'No' }}</span>
      </div>
    </div>

    <ng-container [ngSwitch]="segment.type.id">

      <div class="col-span-full" *ngSwitchCase="SEGMENT_TYPE.TAG">
        <span>{{ segment.tagValue?.viewString }}</span>
      </div>

      <div class="col-span-full whitespace-pre-line" *ngSwitchCase="SEGMENT_TYPE.LITERAL_TEXT">
        <span>{{ segment.text }}</span>
      </div>

      <ng-container *ngSwitchCase="SEGMENT_TYPE.DATE_TIME">
        <div class="col-start-1 segment-prop">
          <span class="font-semibold">Include Date</span>
          <span>{{ segment.includeDate ? 'Yes' : 'No' }}</span>
        </div>
        <div class="segment-prop">
          <span class="font-semibold">Include Time</span>
          <span>{{ segment.includeTime ? 'Yes' : 'No' }}</span>
        </div>
      </ng-container>

      <ng-container *ngSwitchCase="SEGMENT_TYPE.TAG_CHOICE">
        <div class="col-span-full">
          <span>Select from</span>
          <span> {{ segment.tagValue ? segment.tagValue.viewString : 'Any Tag' }} </span>
          <span>at depth</span>
          <span> {{ isValidNumber(segment.depth) ? segment.depth : 'None' }}</span>
        </div>
      </ng-container>

      <ng-container
        *ngSwitchCase="(segment.type.id === SEGMENT_TYPE.FILE_ATTACHMENT || segment.type.id === SEGMENT_TYPE.TAG_CHOICE) ? segment.type.id : ''">
        <div class="col-span-1 col-start-1 segment-prop">
          <span class="font-semibold">Min Required</span>
          <span>{{ segment.minRequired ? segment.minRequired : 'None' }}</span>
        </div>
        <div class="col-span-1 segment-prop">
          <span class="font-semibold">Max Allowed</span>
          <span>{{ segment.maxAllowed ? segment.maxAllowed : 'None' }}</span>
        </div>
      </ng-container>

      <ng-container *ngSwitchCase="SEGMENT_TYPE.SIGNATURE">
        <div class="col-span-full segment-prop items-stretch">
          <span class="font-semibold">People</span>
          <p-table [value]="segment.textList">
            <ng-template pTemplate="header">
              <tr>
                <th style="width: 2em">Required</th>
                <th>Person</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-textItem>
              <tr>
                <td class="p-text-center">
                  <p-checkbox [disabled]="true" [binary]="true" [ngModel]="textItem.required"></p-checkbox>
                </td>
                <td>
                  {{textItem.text}}
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="2" class="p-text-center">
                  <span>None setup</span>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </ng-container>

      <ng-container *ngSwitchCase="SEGMENT_TYPE.NUMERIC_INPUT">
        <div class="col-span-1 col-start-1 segment-prop">
          <span class="font-semibold">Units</span>
          <span>{{ segment.units ? segment.units : 'None' }}</span>
        </div>
        <div class="col-span-1 segment-prop">
          <span class="font-semibold">Min Value</span>
          <span>{{ segment.minValue ? segment.minValue : 'None' }}</span>
        </div>
        <div class="col-span-1 segment-prop">
          <span class="font-semibold">Max Value</span>
          <span>{{ segment.maxValue ? segment.maxValue : 'None' }}</span>
        </div>
        <div class="col-span-full segment-prop">
          <span class="font-semibold">Alert Message Below Min</span>
          <span>{{ stringIsNullOrEmpty(segment.belowMinAlertMessage) ? 'None' : segment.belowMinAlertMessage }}</span>
        </div>
        <div class="col-span-full segment-prop">
          <span class="font-semibold">Alert Message Above Max</span>
          <span>{{ stringIsNullOrEmpty(segment.aboveMaxAlertMessage) ? 'None' : segment.aboveMaxAlertMessage }}</span>
        </div>
      </ng-container>

      <ng-container *ngSwitchCase="SEGMENT_TYPE.TEXT_CHOICE">
        <div class="col-start-1 col-span-2 segment-prop">
          <span class="font-semibold">Choice List</span>
          <span>{{ segment.choiceList?.name }}</span>
        </div>
        <div class="col-span-1 segment-prop">
          <span class="font-semibold">Default Choice</span>
          <span>{{ segment.defaultChoice?.value ?? 'None' }}</span>
        </div>
      </ng-container>

      <ng-container *ngSwitchCase="SEGMENT_TYPE.TEXT_INPUT">
        <div class="col-span-1 col-start-1 segment-prop">
          <span class="font-semibold">Text Style</span>
          <span>{{ segment.textOption === 'ALLOW_RICH_TEXT' ? 'Allow Rich Text' : segment.textOption === 'DEFAULT_TO_RICH_TEXT' ? 'Default to Rich Text' : 'Plain Text Only' }}</span>
        </div>
        <div class="col-span-1 segment-prop">
          <span class="font-semibold">Multi-Line</span>
          <span>{{ isValidNumber(segment.height) && segment.height > 1 ? 'Yes' : 'No' }}</span>
        </div>
        <div class="col-span-1 segment-prop">
          <span class="font-semibold">Barcode or QR-Code</span>
          <span>{{ segment.barcode ? 'Yes' : 'No' }}</span>
        </div>
      </ng-container>

      <ng-container *ngSwitchCase="SEGMENT_TYPE.SIGNOFF">
        <div class="grid gap-y-4 grid-cols-subgrid col-span-full @lg:grid-cols-3">
          <ng-container *ngIf="!segment.allowAnyUser">
            <div *ngIf="segment.users as users" class="flex-grow segment-prop">
              <span class="font-semibold">Initial Users</span>
              <div class="grid">
                <div *ngFor="let user of users" class="col-span-1">
                  <span>{{user.user.firstName}} {{user.user.lastName}}</span>
                </div>
              </div>
              <span *ngIf="!users.length">None</span>
            </div>
            <div *ngIf="segment.userGroups as groups" class="flex-grow segment-prop">
              <span class="font-semibold">Initial Groups</span>
              <div class="grid">
                <div *ngFor="let group of groups" class="col-span-1">
                  <span>{{group.name}}</span>
                </div>
              </div>
              <span *ngIf="!groups.length">None</span>
            </div>
          </ng-container>
          <ng-container *ngIf="segment.allowAnyUser">
            <div class="flex-grow segment-prop">
              <span class="font-semibold">Initial Users</span>
              <span>Any User</span>
            </div>
          </ng-container>
          <div *ngIf="segment.editUsers as editUsers" class="flex-grow segment-prop">
            <span class="font-semibold">Signoff Editors</span>
            <div class="grid">
              <div *ngFor="let user of editUsers" class="col-span-1">
                <span>{{user.user.firstName}} {{user.user.lastName}}</span>
              </div>
            </div>
            <span *ngIf="!editUsers.length">None</span>
          </div>
        </div>
        <div *ngIf="!segment.allowAnyUser" class="col-span-1 segment-prop">
          <span class="font-semibold">Require all signoffs</span>
          <span>{{ segment.requireAllSignoffs ? 'Yes' : 'No' }}</span>
        </div>
        <div class="col-span-1 segment-prop">
          <span class="font-semibold">Allow Reject</span>
          <span>{{ segment.allowReject ? 'Yes' : 'No' }}</span>
        </div>
        <div class="col-span-1 segment-prop">
          <span class="font-semibold">Allow Undo</span>
          <span>{{ segment.allowUndo ? 'Yes' : 'No' }}</span>
        </div>
        <div class="col-span-1 segment-prop">
          <span class="font-semibold">Send Notification on pending</span>
          <span>{{ segment.sendPendingSignoffNotification ? 'Yes' : 'No' }}</span>
        </div>
        <div class="col-span-1 segment-prop">
          <span class="font-semibold">Require on shift</span>
          <span>{{ segment.requireOnShift ? 'Yes' : 'No' }}</span>
        </div>
      </ng-container>
    </ng-container>
    <div *ngIf="segment.calculate" class="calculation-container col-span-full">
      <button pButton
              (click)="showFormulaEditor(segment)"
              class="p-button-text p-p-0 w-full">
        <div class="p-d-flex p-flex-column p-text-left">
          <div>
            <label>Calculation</label>
          </div>
          <div class="p-d-flex p-flex-column p-ai-start" style="font-family: monospace">
            <ng-container *ngIf="formulaMap[segment.id] as scope">
              <div *ngFor="let variable of scope.variables">
                {{ variable.name }} = {{ getReferenceLabelForVariable(variable) }}
              </div>
              <div class="p-mt-3">
                <span *ngIf="!scope.formula" class="p-text-bold">No formula setup</span>
                <span *ngIf="scope.formula" class="whitespace-pre-line">{{ scope.formula }}</span>
              </div>
            </ng-container>
          </div>
        </div>
      </button>
    </div>
  </div>
</ng-template>

<ng-template #segmentFooterButtons>
  <ng-container *ngTemplateOutlet="addSectionButton"></ng-container>

  <ng-container [ngSwitch]="templateType">
    <ng-container *ngSwitchCase="TemplateTypeId.INSPECTION">
      <ng-container *ngTemplateOutlet="addSegmentButton"></ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="TemplateTypeId.OPERATIONAL">
      <ng-container *ngIf="lastSectionNode.value || !hasSubTemplates.value">
        <ng-container *ngTemplateOutlet="addSegmentButton"></ng-container>
      </ng-container>
    </ng-container>
  </ng-container>

</ng-template>

<ng-template #addSectionButton let-relativeTo="relativeTo" let-parent="parent" let-label="label" let-tooltip="tooltip" let-disabled="disabled">
  <ng-container *ngIf="{relativeTo: relativeTo ?? 'after', parent: parent ?? lastSectionNode.value, label, tooltip } as opts">
    <ng-container [ngSwitch]="templateType">
      <ng-container *ngSwitchCase="TemplateTypeId.INSPECTION">
        <button pButton
                class="p-button-success p-button-text"
                [icon]="Icons.PLUS"
                (click)="showSectionEditDialog({ parent: opts.parent, relativeTo: opts.relativeTo, editing: null })"
                [disabled]="!!disabled"
                [label]="label ?? 'Section'"
                [tooltipDisabled]="!!disabled"
                [pTooltip]="tooltip ?? 'Add new section'"></button>
      </ng-container>
      <ng-container *ngSwitchCase="TemplateTypeId.OPERATIONAL">
        <button pButton
                *ngIf="hasSubTemplates.value"
                class="p-button-success p-button-text"
                [icon]="Icons.PLUS"
                [disabled]="!!disabled"
                (click)="showSectionEditDialog({ parent: opts.parent, relativeTo: opts.relativeTo, editing: null })"
                [label]="label ?? 'Subtemplate'"
                [tooltipDisabled]="!!disabled"
                [pTooltip]="tooltip ?? 'Add new subtemplate'"></button>
      </ng-container>
    </ng-container>
  </ng-container>
</ng-template>

<ng-template #addSegmentButton let-prevId="prevId" let-tooltip="tooltip">
  <button (click)="setNewSegmentType(types[0].value, prevId ?? 'last')"
          *ngIf="segmentTypes | async as types"
          [icon]="Icons.PLUS"
          class="p-button-success p-button-text"
          label="Segment"
          pButton
          [pTooltip]="tooltip ? tooltip : 'Add new segment'">
  </button>
</ng-template>

<ng-template #sectionMenuTemplate let-node>
    <ng-container *ngVar="castAs(node, EditorTreeNode) as node">
        <button pButton class="p-button-text p-button-success" [icon]="Icons.PLUS" (click)="sectionMenu.show($event)"></button>
        <p-menu #sectionMenu appendTo="body" [popup]="true" [model]="getSectionAddMenu(node)"></p-menu>
    </ng-container>
</ng-template>

<ng-template #overflowMenuTemplate let-node>
    <ng-container *ngVar="castAs(node, EditorTreeNode) as node">
	      <p-menu #copyMenu appendTo="body" [popup]="true" [model]="getMenuModel(node, 'copy')"></p-menu>
        <p-menu #overflowMenu appendTo="body" [popup]="true" [model]="getMenuModel(node, 'overflow')"></p-menu>
	    
	    <div class="flex">
		    <button (click)="copyMenu.show($event)"
		            *ngIf="selected.length"
		            [icon]="Icons.CLONE"
		            class="p-button-text"
		            pButton
		            pTooltip="Selected segment options"></button>
		    <button (click)="overflowMenu.show($event)"
		            [icon]="Icons.ELLIPSIS_V"
		            class="p-button-text p-button-secondary"
		            pButton
		            pTooltip="More options"></button>
	    </div>
    </ng-container>
</ng-template>

<ng-template #calculationTemplate let-scope let-closeDialog="closeDialog">
    <div class="p-mb-3">
        <lb-formula-editor #formulaEditor [logTimeZone]="logTimeZone" [scope]="scope"></lb-formula-editor>
    </div>
    <p-divider></p-divider>
    <div class="p-d-flex p-jc-end">
        <button [disabled]="formulaEditor.mode == 'variable'" pButton class="p-button-secondary p-mr-3" label="Cancel" (click)="closeDialog()"></button>
        <button [disabled]="formulaEditor.mode == 'variable'" pButton class="p-button-success" label="Save" (click)="saveSegmentCalculation(scope.segment, formulaEditor.getFormulaScope()); closeDialog()"></button>
    </div>
</ng-template>

<p-confirmDialog appendTo="body" [key]="confirmPopupKey"></p-confirmDialog>

<p-dialog (onHide)="hideDialog()"
          [(visible)]="dialogVisible.value"
          [closable]="dialogContext?.closeDialog == null"
          [draggable]="false"
          [focusTrap]="true"
          [header]="dialogContext?.header ?? ''"
          [showHeader]="!!(dialogContext?.header ?? '').length"
          [modal]="true"
          [resizable]="false"
          [responsive]="true"
          [style]="dialogContext?.style ?? { width: '750px' }"
          appendTo="body"
          position="top">
    <ng-container *ngIf="dialogTemplate" [ngTemplateOutlet]="dialogTemplate"
                  [ngTemplateOutletContext]="dialogContext"></ng-container>
</p-dialog>